import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "./Layout";

const Dashboard = ({ onLogout }) => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/customers");
  }, [navigate]);

  return (
    <Layout>
    </Layout>
  );
};

export default Dashboard;
